import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/page.tsx");
